export const DISABLE_QUESTION = 'DISABLE_QUESTION';
export const DISABLE_QUESTION_ERROR = 'DISABLE_QUESTION_ERROR';
export const DISABLE_QUESTION_SUCCESS = 'DISABLE_QUESTION_SUCCESS';
export const DISABLE_QUESTION_LOADING = 'DISABLE_QUESTION_LOADING';
export const DISABLE_QUESTION_RESPONSE = 'DISABLE_QUESTION_RESPONSE';

export const REPORT_QUESTION = 'REPORT_QUESTION';
export const REPORT_QUESTION_ERROR = 'REPORT_QUESTION_ERROR';
export const REPORT_QUESTION_SUCCESS = 'REPORT_QUESTION_SUCCESS';
export const REPORT_QUESTION_LOADING = 'DISABLE_QUESTION_LOADING';
